import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

export default function Layout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1>Two Weeks</h1>
          <span>관리자</span>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/" end>대시보드</NavLink>
          <NavLink to="/users">유저 관리</NavLink>
          <NavLink to="/picks">픽 관리</NavLink>
          <NavLink to="/chains">체인 모니터링</NavLink>
          <NavLink to="/stats">통계 & 분석</NavLink>
          <NavLink to="/settings">시스템 설정</NavLink>
        </nav>
        <div className="sidebar-footer">
          <span>{admin?.name}</span>
          <button onClick={handleLogout}>로그아웃</button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
